import type { TextStyle } from "react-native";

const TEXT_PROPS = [
	"fontSize",
	"lineHeight",
	"fontWeight",
	"fontFamily",
	"fontStyle",
	"color",
	"letterSpacing",
	"textDecorationLine",
] as const;

export type InheritableParent = {
	type: string;
	sourceType?: string;
};

export const walkInheritedStyle = (
	parents: InheritableParent[] | undefined,
	styles: Record<string, TextStyle | undefined> | undefined,
): TextStyle => {
	const merged: TextStyle = {};
	if (!(parents && styles)) {
		return merged;
	}

	for (let i = parents.length - 1; i >= 0; i--) {
		const parent = parents[i];
		if (!parent) {
			continue;
		}
		const style = styles[parent.type];
		if (!style) {
			continue;
		}
		for (const key of TEXT_PROPS) {
			const value = (style as Record<string, unknown>)[key];
			if (value !== undefined) {
				(merged as Record<string, unknown>)[key] = value;
			}
		}
	}
	return merged;
};
